module.exports = __webpack_public_path__ + "static/img/raquelLeft.83058dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/romboTeam/Raquel/raquelLeft.png
// module id = 566
// module chunks = 1